import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Row,
  Col,
  Select,
  Upload,
  message,
  Divider,
  Table,
  DatePicker,
  Modal,
  Space,
} from 'antd'
import {
  UploadOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import AdminHeader from '../CommonComponents/AdminHeader'
import AdminFooter from '../CommonComponents/AdminFooter'
import './StudentAdmissionForm.css'
import { toast } from 'react-toastify'
import axiosInstance from '../../Utils/axiosInstance'
import {
  IMG_URL,
  getChildrenList,
  getNamuna18Data,
  getNamuna45Data,
  saveNamuna18Data,
  saveNamuna20Data,
  saveNamuna22Data,
  saveNamuna45Data,
  saveNamuna7Data,
  saveNamuna9Data,
} from '../APIComponents/AdminApi'
import dayjs from 'dayjs'

const { Option } = Select
const { confirm } = Modal

const NamunaForm = () => {

  //===============================================
  const loginType = sessionStorage.getItem('loginType') // 'ADMIN' or 'USER'
  const menuData = JSON.parse(sessionStorage.getItem('menus')) || []

  const getPagePermission = () => {
    if (loginType === 'ADMIN') {
      return {
        is_new: 1,
        is_edit: 1,
        is_view: 1,
        is_delete: 1,
      }
    }

    for (const menu of menuData) {
      const page = menu.pages?.find((p) => p.page_name === "Namuna 7,9,18,20,22,45 (I C P)")
      if (page) return page
    }

    return {
      is_new: 0,
      is_edit: 0,
      is_view: 0,
      is_delete: 0,
    }
  }

  const pagePermission = getPagePermission()
  const showActionColumn =
    loginType === 'ADMIN' ||
    pagePermission.is_edit == 1 ||
    pagePermission.is_view == 1 ||
    pagePermission.is_delete == 1
  //============================================

  const [form] = Form.useForm()
  const [childList, setChildList] = useState([])
  const [namuna18List, setNamuna18List] = useState([])
  const [namuna45List, setNamuna45List] = useState([])
  const [editRecord, setEditRecord] = useState(null)
  const [loading, setLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [selectedStudent, setSelectedStudent] = useState(null)

  // (GET Children List)============

  useEffect(() => {
    getChildList()
  }, [])

  const getChildList = async () => {
    try {
      setLoading(true)
      const res = await axiosInstance.get(getChildrenList)

      // adjust based on your API response structure
      const data = res?.data || []

      setChildList(data)
    } catch (error) {
      console.error('Error fetching child list:', error)
      toast.error('Failed to load children list')
    } finally {
      setLoading(false)
    }
  }

  // Handle Add ========
  const handleAddNamuna18 = async () => {
    try {
      const values = form.getFieldsValue()

      const fileObj = values.namuna18File?.[0]?.originFileObj

      if (!values.namuna18Date || !fileObj || !values.namuna18ValidUptoDate) {
        toast.error('All fields required')
        return
      }

      const formData = new FormData()
      formData.append('reg_id', values.childName)
      formData.append('uploaded_date', values.namuna18Date.format('YYYY-MM-DD'))
      formData.append(
        'valid_up_to_date',
        values.namuna18ValidUptoDate.format('YYYY-MM-DD'),
      )
      formData.append('upload_file', fileObj)

      const res = await axiosInstance.post(saveNamuna18Data, formData)
      if (res.data == 'SAVED') {
        toast.success('Namuna 18 saved')
      }

      //  Refresh table
      await fetchNamuna18(values.childName)

      //  Clear fields
      form.setFieldsValue({
        namuna18Date: null,
        namuna18File: [],
        namuna18ValidUptoDate: null,
      })
    } catch (err) {
      console.error(err)
      toast.error('Failed to save')
    }
  }

  const handleAddNamuna45 = async () => {
    try {
      const values = form.getFieldsValue()

      //  validation
      if (!values.childName) {
        toast.error('Please select student first')
        return
      }

      const fileObj = values.namuna45File?.[0]?.originFileObj

      if (!values.namuna45Date || !fileObj) {
        toast.error('All fields required')
        return
      }

      setSubmitLoading(true)

      const formData = new FormData()
      formData.append('reg_id', values.childName)
      formData.append('uploaded_date', values.namuna45Date.format('YYYY-MM-DD'))
      formData.append('upload_file', fileObj)

      const res = await axiosInstance.post(saveNamuna45Data, formData)

      if (res?.data === 'SAVED') {
        toast.success('Namuna 45 saved')
      } else {
        toast.success('Namuna 45 submitted')
      }

      //  Refresh table
      await fetchNamuna45(values.childName)

      //  Reset fields
      form.setFieldsValue({
        namuna45Date: null,
        namuna45File: [],
      })
    } catch (err) {
      console.error(err)
      toast.error('Failed to save Namuna 45')
    } finally {
      setSubmitLoading(false)
    }
  }

  const handleAddNamuna22 = async () => {
    try {
      const values = form.getFieldsValue()

      if (!values.childName) {
        toast.error('Select student first')
        return
      }

      const fileObj = values.namuna22File?.[0]?.originFileObj

      if (!values.namuna22Date || !fileObj) {
        toast.error('All fields required')
        return
      }

      const formData = new FormData()
      formData.append('reg_id', values.childName)
      formData.append('uploaded_date', values.namuna22Date.format('YYYY-MM-DD'))
      formData.append('upload_file', fileObj)

      const res = await axiosInstance.post(saveNamuna22Data, formData)
      if (res.data === 'SAVED') {
        toast.success('Namuna 22 saved')
      }

      form.setFieldsValue({
        namuna22Date: null,
        namuna22File: [],
      })
    } catch (err) {
      console.error(err)
      toast.error('Failed to save')
    }
  }

  const handleAddNamuna7 = async () => {
    try {
      const values = form.getFieldsValue()

      const fileObj = values.namuna7File?.[0]?.originFileObj

      if (!values.namuna7Date || !fileObj) {
        toast.error('All fields required')
        return
      }

      const formData = new FormData()
      formData.append('reg_id', values.childName)
      formData.append('uploaded_date', values.namuna7Date.format('YYYY-MM-DD'))
      formData.append('upload_file', fileObj)

      const res = await axiosInstance.post(saveNamuna7Data, formData)
      if (res.data === 'SAVED') {
        toast.success('Namuna 7 saved')
      }

      form.setFieldsValue({
        namuna7Date: null,
        namuna7File: [],
      })
    } catch (err) {
      console.error(err)
      toast.error('Failed to save')
    }
  }

  const handleAddNamuna9 = async () => {
    try {
      const values = form.getFieldsValue()

      const fileObj = values.namuna9File?.[0]?.originFileObj

      if (!values.namuna9Date || !fileObj) {
        toast.error('All fields required')
        return
      }

      const formData = new FormData()
      formData.append('reg_id', values.childName)
      formData.append('uploaded_date', values.namuna9Date.format('YYYY-MM-DD'))
      formData.append('upload_file', fileObj)

      const res = await axiosInstance.post(saveNamuna9Data, formData)
      if (res.data === 'SAVED') {
        toast.success('Namuna 9 saved')
      }

      form.setFieldsValue({
        namuna9Date: null,
        namuna9File: [],
      })
    } catch (err) {
      console.error(err)
      toast.error('Failed to save')
    }
  }

  const handleAddNamuna20 = async () => {
    try {
      const values = form.getFieldsValue()

      const fileObj = values.namuna20File?.[0]?.originFileObj

      if (!values.namuna20Date || !fileObj) {
        toast.error('All fields required')
        return
      }

      const formData = new FormData()
      formData.append('reg_id', values.childName)
      formData.append('uploaded_date', values.namuna20Date.format('YYYY-MM-DD'))
      formData.append('upload_file', fileObj)

      const res = await axiosInstance.post(saveNamuna20Data, formData)
      if (res.data === 'SAVED') {
        toast.success('Namuna 20 saved')
      }

      form.setFieldsValue({
        namuna20Date: null,
        namuna20File: [],
      })
    } catch (err) {
      console.error(err)
      toast.error('Failed to save')
    }
  }

  // Table Columns=========
  const getNamuna18Columns = (type) => [
    {
      title: 'Date',
      render: (_, r) => r.uploaded_date?.format('DD-MM-YYYY'),
    },
    ...(type === 'namuna18'
      ? [
          {
            title: 'Valid Upto',
            render: (_, r) => r.valid_up_to_date?.format('DD-MM-YYYY'),
          },
        ]
      : []),
    {
      title: 'File',
      render: (_, r) => r.upload_file,
    },
  ]

  const getNamuna45Columns = () => [
    {
      title: 'Uploaded Date',
      dataIndex: 'uploaded_date',
      render: (date) => date?.format('DD-MM-YYYY'),
    },
    {
      title: 'File',
      dataIndex: 'upload_file',
    },
  ]

  // ================= FILE VALIDATION =================
  const validateFile = (file) => {
    const allowedTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'application/pdf',
    ]

    const isAllowedType = allowedTypes.includes(file.type)

    if (!isAllowedType) {
      toast.error('Only JPG, PNG, and PDF files are allowed!')
      return Upload.LIST_IGNORE
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
      toast.warn('File must be smaller than 3MB!')
      return Upload.LIST_IGNORE
    }

    return false // prevent auto upload
  }

  //===============================================================
  //===============================================================

  useEffect(() => {
    if (!selectedStudent) return

    fetchNamuna18(selectedStudent)
    fetchNamuna45(selectedStudent)
  }, [selectedStudent])

  const handleStudentChange = (value) => {
    setSelectedStudent(value)
    form.setFieldsValue({ childName: value })
  }

  const fetchNamuna18 = async (regId) => {
    try {
      const res = await axiosInstance.get(`${getNamuna18Data}/${regId}`)

      const formatted =
        res?.data?.map((item) => ({
          id: item.id,
          uploaded_date: dayjs(item.uploaded_date), // ✅ match column
          valid_up_to_date: dayjs(item.valid_up_to_date), // ✅ match column
          upload_file: (
            <a
              href={IMG_URL + item.upload_file}
              target="_blank"
              rel="noreferrer"
            >
              View File
            </a>
          ),
        })) || []

      setNamuna18List(formatted)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchNamuna45 = async (regId) => {
    try {
      const res = await axiosInstance.get(`${getNamuna45Data}/${regId}`)

      const formatted =
        res?.data?.map((item) => ({
          id: item.id,

          //  convert string → dayjs
          uploaded_date: dayjs(item.uploaded_date),

          //  clickable file link
          upload_file: (
            <a
              href={IMG_URL + item.upload_file}
              target="_blank"
              rel="noreferrer"
            >
              View File
            </a>
          ),
        })) || []

      setNamuna45List(formatted)
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <>
      <AdminHeader />
      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper p-4 pt-0">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">Namuna Form</h3>
          </div>

          <div className="row student-form-container shadow p-4 rounded bg-white">
            <Form form={form} layout="vertical">
              <Row gutter={16} className="mt-3 border rounded p-2">
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Select Children Name"
                    name="childName"
                    rules={[{ required: true, message: 'Please select child' }]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          ?.toString()
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Choose child name"
                      loading={loading}
                      onChange={handleStudentChange}
                    >
                      {childList.map((child) => (
                        <Option key={child.id} value={child.id}>
                          {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                          {child.reg_no})
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <div
                style={{
                  pointerEvents: !selectedStudent ? 'none' : 'auto',
                  opacity: !selectedStudent ? 0.5 : 1,
                }}
              >
                {/* ===================  NAMUNA 18 =================== */}

                <Divider />
                <div className="divider-left-only">
                  <h5>Namuna 18 / Extension Entry -</h5>
                </div>

                <Row gutter={16} className="border rounded p-2">
                  <Col xs={24} md={6}>
                    <Form.Item
                      label="Uploaded Date"
                      name="namuna18Date"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Upload File"
                      name="namuna18File"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                    >
                      <Upload
                        beforeUpload={validateFile}
                        accept=".jpg,.jpeg,.png,.pdf"
                        listType="picture"
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: '100%' }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={6}>
                    <Form.Item
                      label="Valid Upto Date"
                      name="namuna18ValidUptoDate"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={5} style={{ paddingTop: '30px' }}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={handleAddNamuna18}
                    >
                      Submit
                    </Button>
                  </Col>

                  <Col xs={24}>
                    <Table
                      dataSource={namuna18List}
                      columns={getNamuna18Columns()}
                      pagination={false}
                      bordered
                      rowKey="id"
                      className="custom-table shadow"
                      style={{ overflowX: 'auto' }}
                    />
                  </Col>
                </Row>

                {/* =================== NAMUNA 22 ===================*/}
                <Divider />
                <div className="divider-left-only">
                  <h5>Namuna 22 -</h5>
                </div>

                <Row gutter={16} className="border rounded p-2">
                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Uploaded Date"
                      name="namuna22Date"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Upload File"
                      name="namuna22File"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                    >
                      <Upload
                        beforeUpload={validateFile}
                        accept=".jpg,.jpeg,.png,.pdf"
                        listType="picture"
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: '100%' }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={5} style={{ paddingTop: '30px' }}>
                    <Button type="primary" onClick={handleAddNamuna22}>
                      Submit
                    </Button>
                  </Col>
                </Row>

                {/* =================== NAMUNA 45 =================== */}
                <Divider />
                <div className="divider-left-only">
                  <h5>Namuna 45 -</h5>
                </div>

                <Row gutter={16} className="border rounded p-2">
                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Uploaded Date"
                      name="namuna45Date"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Upload File"
                      name="namuna45File"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                    >
                      <Upload
                        beforeUpload={validateFile}
                        accept=".jpg,.jpeg,.png,.pdf"
                        listType="picture"
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: '100%' }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={6} style={{ paddingTop: '30px' }}>
                    <Button
                      type="primary"
                      loading={submitLoading}
                      icon={<PlusOutlined />}
                      onClick={handleAddNamuna45}
                    >
                      Submit
                    </Button>
                  </Col>

                  <Col xs={24}>
                    <Table
                      dataSource={namuna45List}
                      columns={getNamuna45Columns()}
                      pagination={false}
                      bordered
                      rowKey="id"
                      className="custom-table shadow"
                      style={{ overflowX: 'auto' }}
                    />
                  </Col>
                </Row>

                {/* =================== NAMUNA 7  =================== */}
                <Divider />
                <div className="divider-left-only">
                  <h5>Namuna 7 -</h5>
                </div>

                <Row gutter={16} className="border rounded p-2">
                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Uploaded Date"
                      name="namuna7Date"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Upload File"
                      name="namuna7File"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                    >
                      <Upload
                        beforeUpload={validateFile}
                        accept=".jpg,.jpeg,.png,.pdf"
                        listType="picture"
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: '100%' }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={5} style={{ paddingTop: '30px' }}>
                    <Button type="primary" onClick={handleAddNamuna7}>
                      Submit
                    </Button>
                  </Col>
                </Row>

                {/* =================== NAMUNA 9  =================== */}
                <Divider />
                <div className="divider-left-only">
                  <h5>Namuna 9 -</h5>
                </div>

                <Row gutter={16} className="border rounded p-2">
                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Uploaded Date"
                      name="namuna9Date"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Upload File"
                      name="namuna9File"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                    >
                      <Upload
                        beforeUpload={validateFile}
                        accept=".jpg,.jpeg,.png,.pdf"
                        listType="picture"
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: '100%' }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={5} style={{ paddingTop: '30px' }}>
                    <Button type="primary" onClick={handleAddNamuna9}>
                      Submit
                    </Button>
                  </Col>
                </Row>

                {/* =================== NAMUNA 20 =================== */}
                <Divider />
                <div className="divider-left-only">
                  <h5>Namuna 20 -</h5>
                </div>

                <Row gutter={16} className="border rounded p-2">
                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Uploaded Date"
                      name="namuna20Date"
                      rules={[{ required: true, message: 'Select date' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={7}>
                    <Form.Item
                      label="Upload File"
                      name="namuna20File"
                      valuePropName="fileList"
                      getValueFromEvent={(e) => e.fileList}
                    >
                      <Upload
                        beforeUpload={validateFile}
                        accept=".jpg,.jpeg,.png,.pdf"
                        listType="picture"
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          style={{ width: '100%' }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={5} style={{ paddingTop: '30px' }}>
                    <Button type="primary" onClick={handleAddNamuna20}>
                      Submit
                    </Button>
                  </Col>
                </Row>
              </div>

              {/* ============================================================================ */}
            </Form>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}

export default NamunaForm
